<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <template v-if="!photo">
      <label v-if="label" :for="name">{{ label }}</label>
      <div class="input-group input-file" :class="additionalClass">
        <label class="input-group-btn">
        <span class="btn btn-info">
          <i class="fa fa-fw fa-upload"></i><div class="visible-md-inline visible-lg-inline"> Selecionar</div>
          <input type="file"
                 :multiple="multiple"
                 :name="name"
                 :required="required"
                 @click="onClick($event.target)"
                 @change="onChange($event.target.files)"
                 style="display: none;"
          />
        </span>
        </label>
        <input type="text" class="form-control" :placeholder="placeholder" v-model="fileText" readonly>
      </div>
    </template>
    <template v-else="">
      <div class="input-file" :class="additionalClass">
        <label class="btn btn-info bold" :class="{ 'disabled' : loading }">
          <template v-if="loading">ENVIANDO <i class="fa fa-fw fa-spin fa-spinner"></i></template>
          <template v-else>ENVIAR FOTO <i class="fa fa-fw fa-camera"></i></template>
          <input type="file"
                 :disabled="loading"
                 :multiple="multiple"
                 :name="name"
                 :required="required"
                 @click="onClick($event.target)"
                 @change="onChange($event.target.files)"
                 style="display: none;"
          />
        </label>
      </div>
    </template>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default{
    name: 'InputFile',
    props: {
      text: {},
      loading: { type: Boolean, default: false },
      label: { type: String, default: '' },
      name: { type: String, default: '' },
      photo: { type: Boolean, default: false },
      additionalClass: { type: String, default: '' },
      placeholder: { type: String, default: '' },
      required: { type: Boolean, default: false },
      multiple: { type: Boolean, default: false },
      error: {}
    },
    data () {
      return {
        fileText: ''
      }
    },
    computed: {
      ...mapState({
        company: state => state.company
      })
    },
    methods: {
      onClick (target) {
        target.value = ''
      },
      onChange (files) {
        this.$emit('change', allFiles)
        // get the files
        // let files = e.target.files
        // Process each file
        var allFiles = []
        for (var i = 0; i < files.length; i++) {
          let file = files[i]
          // Make new FileReader
          let reader = new window.FileReader()
          // Convert the file to base64 text
          reader.readAsDataURL(file)
          // on reader load somthing...
          reader.onload = () => {
            // Make a fileInfo Object
            let fileInfo = {
              name: file.name,
              base64: reader.result,
              type: file.type
              // size: Math.round(file.size / 1000) + ' kB',
            }
            // Push it to the state
            allFiles.push(fileInfo)
            // If all files have been proceed
            if (allFiles.length === files.length) {
              // Apply Callback function
              if (this.multiple) {
                this.fileText = allFiles.length + ' arquivos carregados'
                this.$emit('input', allFiles)
              } else {
                this.fileText = allFiles[0].name
                this.$emit('input', allFiles[0])
              }
            }
          } // reader.onload
        } // for
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InputFile.vue?5cb80df5